import React from "react";
import { MoreActions } from "ui/modules/MoreActions";
import EditIcon from "@material-ui/icons/Edit";
import Delete from "@material-ui/icons/Delete";
import Dots from "@material-ui/icons/DragIndicator";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { isInteger, is_empty } from "utils/validations";
import moduleStyle from "./FooterItemList.module.css";
import { CustomFooterContext } from "../..";

export const FooterItemList = ({ section_side }) => {
  const {
    previewData: data,
    set_data,
    set_show_modal,
    set_selected_record,
    handleDelete,
    disableAllEdits,
  } = React.useContext(CustomFooterContext);

  if (is_empty(data[section_side.key])) return null;

  const options = [
    {
      title: "Edit",
      icon: <EditIcon />,
      handleClick: () => set_show_modal(true),
    },
    {
      title: "Delete",
      icon: <Delete />,
      handleClick: () => handleDelete(),
    },
  ];

  const handleOnDragEnd = (result) => {
    if (
      !isInteger(result?.destination?.index) ||
      !isInteger(result?.source?.index)
    )
      return;
    let temp = data[section_side.key];
    const reorderedData = temp.splice(result.source.index, 1);
    temp.splice(result.destination.index, 0, ...reorderedData);
    for (let i = 0; i < temp.length; i++) {
      let item = temp[i];
      item.id = i;
    }

    set_data({ ...data, [section_side.key]: temp });
  };

  return (
    <>
      <div className={`${moduleStyle.label} mb-2`}>{section_side.label}</div>
      <DragDropContext onDragEnd={handleOnDragEnd}>
        <Droppable
          droppableId={section_side.key}
          type={section_side.key.toUpperCase()}
          mode="standard"
        >
          {(provided) => {
            return (
              <div ref={provided.innerRef}>
                {data[section_side.key]
                  ?.filter((item) => !item.draft)
                  .map((item, index) => (
                    <Draggable
                      key={`${section_side.key}-${item?.id}`}
                      draggableId={`${section_side.key}-${item?.id}`}
                      index={index}
                    >
                      {(provided) => (
                        <div>
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                          >
                            <>
                              <div className={`mt-2 mb-2 position-relative`}>
                                {provided && (
                                  <div
                                    className={`mr-1 grab ${moduleStyle.drag_svg}`}
                                    {...provided.dragHandleProps}
                                  >
                                    <Dots />
                                  </div>
                                )}
                                <div className={`${moduleStyle.card}`}>
                                  <div className={`${moduleStyle.dots_svg}`}>
                                    {disableAllEdits ? null : (
                                      <div
                                        onClick={() =>
                                          set_selected_record(item)
                                        }
                                      >
                                        <MoreActions
                                          options={options}
                                          shift={{ x: 45, y: 70 }}
                                        />
                                      </div>
                                    )}
                                  </div>
                                  <div
                                    className={`${moduleStyle.card_title} line_max_1 ${moduleStyle.clip_title}`}
                                  >
                                    {item?.text}
                                  </div>
                                </div>
                              </div>
                            </>
                          </div>
                          {provided.placeholder}
                        </div>
                      )}
                    </Draggable>
                  ))}
                {provided.placeholder}
              </div>
            );
          }}
        </Droppable>
      </DragDropContext>
    </>
  );
};
